import { createTabSlice } from './createTabSlice'

const steps = ["settlementList", "settlementDrafts", "recentSettlement", "unpaidOrders"] as const;
export type settlementTabStep = (typeof steps)[number];

const slice = createTabSlice({
	name: "settlementTab",
	steps,
});

export const { setActiveKey } = slice.actions;
export default slice.reducer;

